import { LabourEngagementEmploymentType } from 'api/services/workforce/workforce-service.types';

const employmentTypeTranslationKey: Record<LabourEngagementEmploymentType, string> = {
  EMPLOYEE: 'employment-type.employee',
  FREELANCER: 'employment-type.freelancer',
  TEMPWORKER: 'employment-type.tempworker',
};

const isLabourEngagementEmploymentType = (
  employmentType: string
): employmentType is LabourEngagementEmploymentType =>
  employmentType === 'EMPLOYEE' ||
  employmentType === 'FREELANCER' ||
  employmentType === 'TEMPWORKER';

export function getEmploymentTypeLabel(
  employmentType: LabourEngagementEmploymentType,
  translate: (key: string) => string
): string;
export function getEmploymentTypeLabel(
  employmentType: string | null | undefined,
  translate: (key: string) => string
): string | null;
export function getEmploymentTypeLabel(
  employmentType: string | null | undefined,
  translate: (key: string) => string
): string | null {
  if (employmentType == null || !isLabourEngagementEmploymentType(employmentType)) {
    return null;
  }

  return translate(employmentTypeTranslationKey[employmentType]);
}
